import { render, staticRenderFns } from "./DocumentTypesPage.vue?vue&type=template&id=6926d423&scoped=true"
import script from "./DocumentTypesPage.vue?vue&type=script&lang=js"
export * from "./DocumentTypesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6926d423",
  null
  
)

export default component.exports